module.exports = __webpack_public_path__ + "img/template2.748bf788.png";